module.exports = __webpack_public_path__ + "static/001-2b86ed570b2cfa7d9067bcd3392cc06e.jpg";